<template>
  <div class="tornoment-modules" :style="{backgroundImage: `url(${this.$route.params.background})`}">


    <div v-if="modalOpened" class="madalbackground" @click="closeModals"></div>
    <!--</transition>-->
    <!--edit profile and new user forced-->

    <div class="container">
      <transition tag="div" name="slideUp">
        <div class="mandatory-modal" v-if="rulesModal">
          <h5 class="text-center mt-3">قوانین و مقررات</h5>

          <img class="rule-image text-center mb-3" src="~@/assets/img/tornoments/rules-icon.png">

          <div class="input-container" v-html="rules"></div>

        </div>
      </transition>
    </div>


    <div class="tornoment-items d-flex justify-content-center flex-column p-4">

      <div class="d-flex flex-row flex-row-reverse">
        <div class="mb-4 tornoment-item text-center" @click="gotoGp()">

                <img :src="`${item}`">
                <div class="item-title">{{lists[0].title}}</div>
        </div>

        <div class="mb-4 tornoment-item text-center" @click="gotoGp()">
          <img :src="`${item}`">
          <div class="item-title">{{lists[1].title}}</div>
        </div>
      </div>

      <div class="d-flex flex-row flex-row-reverse">
        <div class="mb-4 tornoment-item text-center" @click="gotoGp()">
          <img :src="`${item}`">
          <div class="item-title">{{lists[2].title}}</div>
        </div>

        <div class="mb-4 tornoment-item text-center" @click="gotoGp()">
          <img :src="`${item}`">
          <div class="item-title">{{lists[3].title}}</div>
        </div>
      </div>

      <div class="d-flex finalimagesection flex-column align-items-center text-center" @click="gotoFinal()">
        <img :src="`${final}`">
      </div>


        <div class="rules-btn d-flex flex-row flex-row-reverse" @click="openRulesModal">
          <img class="iconrule" src="~@/assets/img/tornoments/rules-icon.png">
          قوانین و مقررات
        </div>

    </div>

  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      lists:null,
      modalOpened:false,
      rulesModal:false,
      rules:null,
      item:null,
      final:null
    };
  },
  created(){
      this.getTorItems();
      this.item = this.$route.params.item;
      this.final = this.$route.params.final;
  },
  computed: {

  },
  methods: {
    async getTorItems() {

      let fd = new FormData();

      fd.append("gtid", this.$route.params.id);
      const response = await this.$ApiServiceLayer.post("get_tornoments_list", fd);
      console.log(response);

      if (response) {
        this.lists = response.list;
        this.rules = response.rules;
      }
    },
    closeModals() {
      this.modalOpened = false;
      this.rulesModal = false;
    },
    openRulesModal(data){
      this.rulesModal = true;
      this.modalOpened = true;
    },

    gotoGp(){
      this.$toast.open({
        message: 'این گروه کاربری برای نمایش ندارد.',
        type: 'error',
      });
    },
    gotoFinal(){
      this.$toast.open({
        message: 'این تورنومنت هنوز به فینال و مسابقه نهایی نرسیده است.',
        type: 'error',
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tornoment-modules {
  //background-image: url("~@/assets/img/bg/tornoments.jpg");
  width: 100%;
  min-height: 100%;
  height: 100vh;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  /*  background: url("~@/assets/img/bg/fifa_t_back.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;*/

  .mandatory-modal {
    position: fixed;
    height: 410px;
    width: 100%;
    background-color: #fff;
    //border-radius: 10px;
    //transform: translate(-50%, -50%);
    padding: 0px !important;
    direction: rtl;
    z-index: 2;
    overflow-y:scroll;
    overflow-x:hidden;
    //border: 1px dashed #80808033;
    bottom: 0;
    left: 0;
    .title {
      width: 100%;
      height: 3px;
      /* background-color: blue; */
      /* margin-top: 40px; */
      text-align: center;
      /* position: relative; */
      margin-bottom: 51px;
      p {
        padding: 10px 20px;
        background-color: white;
        font-family: "sansb";
        font-size: 20px;
        font-weight: bold;
      }
    }
    .desc {
      width: 100%;
      padding: 0 20px;
      text-align: right;
      margin-top: 20px;
      padding-bottom: 10px;
      p {
        font-family: "sans";
        font-size: 17px;
        line-height: 28px;
        white-space: pre-line;
      }
    }
    .image-box{
      img{
        width: 100%;
        height: 180px;
      }
    }
    .input-container{
      //position: fixed;
      bottom: 0px;
      height: auto;
      background: #ffffff;
      width: 100%;
      /*display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 0 auto;*/
      //justify-content: space-around;
      padding: 8px 8px 7px 8px;
      font-family: "sans";
      font-size: 17px;
      line-height: 28px;
      white-space: pre-line;
      .buy-ticket.disactive{
        background: #37474f;
        color:#ffffff;
        width: 70%;
        padding: 9px;
        margin-bottom: 5px;
      }
      .buy-ticket.active{
        background: #37474f;
        color:#ffffff;
        width: 70%;
        padding: 9px;
      }
    }

    .rule-image{
      width: 36%;
      height: 50%;
      margin: 0 auto;
      display: flex;
    }
  }

  .title-container-box{
    background: #ffffff;
    padding: 15px 15px 40px 15px;
    width: 92%;
    border-radius: 0 0 20px 20px;
    margin-bottom: 33px;
      .image-box{
        img{
          width: 130px;
          height: 130px;
          border-radius: 50%;
          margin-bottom: 20px;
          border: 2px solid #9e9e9e;
          box-shadow: 1px 1px 14px 2px #9e9e9ea1;
        }
      }

      .computer-title{
        h3{

        }
        p{
          color:#757575;
        }
      }
  }

  .tornoment-items{
    padding-top: 140px !important;
    .tornoment-item{
      padding: 14px 14px 5px 14px;
      border-radius: 30px;
      position: relative;
      img{
        border-radius: 30px;
        width: 90%;

      }
      .item-title{
        position: absolute;
        top: 41%;
        right: 24%;
        background: #ffffffd1;
        width: 51%;
        padding: 11px;
        border-radius: 12px;
        font-weight: bold;
        font-size: 21px;
        direction: rtl;
      }
    }
    .finalimagesection{
      img{
        width: 70%;
      }
    }
    .rules-btn{
      background: #ffffff4a;
      border-radius: 12px;
      color: #ffffff;
      width: fit-content;
      padding: 11px;
      position: absolute;
      right: 10px;
      bottom: 5px;
      .iconrule{
          width: 30px;
          height: 30px;
          margin-left: 12px;
      }
    }
  }

  .madalbackground{
    width: 100%;
    height: inherit;
    background: #0000006e;
    position: fixed;
    z-index: 1;
  }
}
</style>
